/** Simple loading service to trigger overlay in App.tsx */

type SetLoading = (loading: boolean) => void;

let _setLoading: SetLoading;

export function initializePageLoading(setLoading: SetLoading): void {
    _setLoading = setLoading;
}

export function setPageLoading(loading: boolean): void {
    _setLoading(loading);
}

export default { initializePageLoading, setPageLoading };
